import api from './axiosInstance';
export const getLookup = () => api.get('/estimations/lookup');
export const getAll = () => api.get('/estimations');
export const getById = (id) => api.get(`/estimations/${id}`);
export const create = (data) => api.post('/estimations', data);
export const deleteEstimation = (id) => api.delete(`/estimations/${id}`);
export const deleteLineItem = (estimationId, itemId) =>
  api.delete(`/estimations/${estimationId}/items/${itemId}`);

export const deleteAccessoryLineItem = (estimationId, itemId) =>
  api.delete(`/estimations/${estimationId}/accessory-items/${itemId}`);

export const downloadExcel = async (id) => {
  const blob = await api.get(`/estimations/${id}/excel`, { responseType: 'blob' });
  const url = window.URL.createObjectURL(blob instanceof Blob ? blob : new Blob([blob]));
  const a = document.createElement('a');
  a.href = url;
  a.download = `estimation_${id}.xlsx`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};
